import {
  getPowerPlant as apiGetPowerPlant,
  getPictogramJson as apiGetPictogramJson,
  getProjectPictograms as apiGetProjectPictograms,
  getPhotovoltaicPanel3 as apiGetPhotovoltaicPanel3,
  getViewBinary as apiGetViewBinary,
  getViewStatuses as apiGetViewStatuses,
  getPictogramNames as apiGetPictogramNames,
  getPictogramComponent as apiGetPictogramComponent,
  savePowerPlant as apiSavePowerPlant,
  savePowerPlantScreenshot as apiSavePowerPlantScreenshot,
} from '../api'

// Servicio del power plant: punto único por el que el componente accede al api
// (regla: componente → servicio → api). De momento es un paso fino sobre el api;
// la orquestación de carga/render (pool de descargas, procesado de escena,
// armado del FormData) sigue en ViewerDesign por su acople al motor de render, y se
// moverá aquí cuando se separe el motor (p.ej. al migrar a Three.js).

export const fetchPowerPlant = (entityId, entityType) =>
  apiGetPowerPlant(entityId, entityType)

export const fetchPictogramJson = (pictogramId) =>
  apiGetPictogramJson(pictogramId)

// Pictogramas del proyecto (dashboard FV) para el panel de info del parque.
export const fetchProjectPictograms = (projectId, options) =>
  apiGetProjectPictograms(projectId, options)

// Serie temporal (curva S) por grupo raíz del proyecto para el panel de info.
export const fetchPhotovoltaicPanel3 = (projectId, params) =>
  apiGetPhotovoltaicPanel3(projectId, params)

// Descarga el binario .epcp de una vista del parque (ArrayBuffer). Lanza 404 si no
// existe (el componente lo captura y cae al JSON).
export const fetchViewBinary = (powerPlantId, view) =>
  apiGetViewBinary(powerPlantId, view)

// Estado por entidad + color de una vista (Mongo). Para pintar en color la geometría
// cargada desde el binario (que viene sin estado).
export const fetchViewStatuses = (powerPlantId, view, withIncidents = false) =>
  apiGetViewStatuses(powerPlantId, view, withIncidents)

// Nombres de las entidades de un pictograma (Mongo). Para las etiquetas al enfocar.
export const fetchPictogramNames = (powerPlantId, pictogramId, view) =>
  apiGetPictogramNames(powerPlantId, pictogramId, view)

// Info de un elemento (componente): historial, estado actual, atributos y certificación.
// Para el popover del elemento al hacer click en el modo foco.
export const fetchPictogramComponent = (pictogramId, componentId, workLayer) =>
  apiGetPictogramComponent(pictogramId, componentId, workLayer)

export const savePowerPlant = (entityId, form, powerPlantId) =>
  apiSavePowerPlant(entityId, form, powerPlantId)

export const savePowerPlantScreenshot = (powerPlantId, form) =>
  apiSavePowerPlantScreenshot(powerPlantId, form)
